import { useEffect, useState } from "react";
import { Alert } from "reactstrap";
export default function AlertComponent({ alert, time, close,topright }) {
  const [data, setData] = useState();
  const message = typeof alert === "string" ? alert : alert?.message;
  const status = typeof alert === "string" ? "" : String(alert?.status || "").toLowerCase();
  const alertColor =
    status === "error" || status === "danger"
      ? "danger"
      : status === "warning" || status === "warn"
        ? "warning"
        : status === "success"
          ? "success"
          : topright === "bottom" || topright === "normal"
            ? "primary"
            : "success";

  useEffect(() => {
    setData(message);
    return () => setData();
  }, [message]);
  useEffect(() => {
    if (data) {
      let timeout = setTimeout(() => {
        setData();
        close && close();
      }, time ?? 5000);
      return () => {
        setData();
        clearTimeout(timeout);
      };
    }
  }, [close, data, time]);
  if (!data) return null;
  return (
<>
  {topright === 'bottom' ? (
    <div className="alert-position-below">
      <Alert
        color={alertColor}
        className="mb-0 shadow d-flex"
        isOpen={!!data}
        toggle={() => {
          setData();
          close && close();
        }}
        style={{
          width: "100%",
          borderRadius: 10,
          zIndex: 10,
          textAlign: "center",
        }}
      >
        {data}
      </Alert>
    </div>
  ) : topright === 'normal' ? (
    <div className="normal-alert">
      <Alert
        color={alertColor}
        className="mb-0 shadow d-flex"
        isOpen={!!data}
        toggle={() => {
          setData();
          close && close();
        }}
        style={{
          width: "100%",
          borderRadius: 10,
          zIndex: 10,
          textAlign: "center",
        }}
      >
        {data}
      </Alert>
    </div>
  ) : topright === 'top' ? (
    <div className="global-alert--right">
      <Alert
        color={alertColor}
        className="mb-0 shadow d-flex"
        isOpen={!!data}
        toggle={() => {
          setData();
          close && close();
        }}
        style={{
          width: "100%",
          borderRadius: 10,
          zIndex: 10,
          textAlign: "left",
        }}
      >
        {data}
      </Alert>
    </div>
  ) : (
    <div className="global-alert">
      <Alert
        color={alertColor}
        className="mb-0 shadow d-flex"
        isOpen={!!data}
        toggle={() => {
          setData();
          close && close();
        }}
        style={{
          width: "100%",
          borderRadius: 10,
          zIndex: 10,
          textAlign: "center",
        }}
      >
        {data}
      </Alert>
    </div>
  )}
</>

  );
}
